import {debug} from 'loglevel'
import Vue from 'vue'
import Vuex from 'vuex'
// import createPersistedState from 'vuex-persistedstate'
import {
  find_mainset,
  objectToQueryString,
} from "@/api/util.js"
import {site_settings, toc_options} from "@/site_settings"

Vue.use(Vuex)

window.addEventListener('resize', () => {
  // debug('setWindowHeight', window.innerHeight)
  store.commit('setWindowHeight', window.innerHeight)
})

const {theme, theme_name, mainset_id, mainset_name, test} = site_settings()
const jinfo = require("@/../sdata/jinfo.json")
import {getIdentity} from "@/api/token"
const {uname, auth_type, allow, allow_uniname} = getIdentity()
const isadmin = Boolean(allow && allow.includes('admin'))
const store = new Vuex.Store({
  state: {
    // error_messages: [],
    mmm: '',
    err_count: 0,
    windowHeight: window.innerHeight,
    subtitle: null,
    test: !!test,  // 內部測試模式
    test_default: !!test,
    theme,
    theme_name,
    mainset_id,
    mainset_name,
    uniname: undefined,
    journal_name: undefined,
    journal_en_name: undefined,
    current_path: undefined,

    uname,
    auth_type,
    isadmin,
    allow,
    allow_uniname,

    pubyears: undefined,
    show_advsearch_tip_count: 0,
    test_mode: 0,
  },
  mutations: {
    login() {},
    logout() {},
    set_locale() {},
    set_test_mode(state, test_mode) {
      state.test_mode = test_mode
    },
    show_advsearch_tip(state) {
      state.show_advsearch_tip_count += 1
    },
    hide_app_drawer() {
    },
    set_test(state, test) {
      // debug('set_test', typeof test, test)
      state.test = !!test
    },
    set_pubyears(state, {pubyears}) {
      state.pubyears = pubyears
    },
    set_login(state, {uname, auth_type, allow}) {
      state.uname = uname
      state.auth_type = auth_type
      state.allow = allow
      state.isadmin = Boolean(allow && allow.includes('admin'))
    },
    set_progress() { // set_progress(_, {progress, show}) {
        // debug('set_progress', {progress, show})
    },
    to_path(state, {path, query}) {
      debug('to_path', path, query)
      const qstr = objectToQueryString(query)
      debug('qstr', qstr)
      if(qstr) {
        state.current_path = path + '?' + qstr
      }
      else {
        state.current_path = path
      }
    },
    set_mainset(state, mainset_id) {
      // debug('store::set_mainset', mainset_id)
      const mainset_ = toc_options.find((i)=>(i.id == mainset_id) || (i.id == `${mainset_id}_mainset`))
      const mainset_name = mainset_ ? mainset_.name : '臺灣學術經典'
      state.mainset_id = mainset_id
      state.mainset_name = mainset_name
    },
    set_uniname(state, uniname) {
      // debug('store::set_uniname', uniname)
      if(uniname) {
        uniname = uniname.slice(0, 3)
        const opt = find_mainset(uniname)
        state.uniname = uniname
        if(jinfo[uniname]) {
          state.journal_name = jinfo[uniname].journal_name
          state.journal_en_name = jinfo[uniname].journal_en_name
        }
        this.commit('set_mainset', opt.mainset_id ? opt.mainset_id : opt.id)
      }
      else {
        state.mainset_id = state.uniname = undefined
        state.mainset_name = state.journal_name = undefined
      }
    },
    error(state, msg) {
      // state.error_messages.push(msg);
      state.mmm = msg
      state.err_count++
    },
    toggle_context_sidebar() {
    },
    setWindowHeight(state, innerHeight) {
      state.windowHeight = innerHeight
    },
  },
  actions: {
  },
  modules: {
  },
  // plugins: [createPersistedState({
  //   storage: window.localStorage,
  //   reducer(val) {
  //     return {
  //       access_token: val.access_token,
  //       refresh_token: val.refresh_token,
  //     }
  //   },
  // })]
})

export default store
